var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41129 4.598C1.282 4.46871 1.10664 4.39607 0.923798 4.39607C0.740952 4.39607 0.565594 4.46871 0.436302 4.598C0.307011 4.72729 0.234375 4.90265 0.234375 5.0855C0.234375 5.26834 0.307011 5.4437 0.436302 5.57299L2.49614 7.63283C2.5603 7.69647 2.63639 7.74682 2.72004 7.78099C2.8037 7.81515 2.89328 7.83247 2.98364 7.83195C3.07764 7.82897 3.17002 7.80671 3.25506 7.76655C3.3401 7.7264 3.41598 7.6692 3.478 7.5985L8.2843 2.10559C8.39528 1.96781 8.44879 1.7925 8.43367 1.61623C8.41855 1.43996 8.33598 1.27632 8.20316 1.15945C8.07035 1.04257 7.89754 0.981467 7.72078 0.988886C7.54401 0.996304 7.37693 1.07167 7.25438 1.19926L2.98364 6.14288L1.41129 4.598Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.fad1656e941d2e8d570bc108b4bd8669.svg";
export { ForwardRef as ReactComponent };